import { render, staticRenderFns } from "./plane-proposal.vue?vue&type=template&id=073efb6c&scoped=true&"
import script from "./plane-proposal.vue?vue&type=script&lang=js&"
export * from "./plane-proposal.vue?vue&type=script&lang=js&"
import style0 from "./plane-proposal.vue?vue&type=style&index=0&id=073efb6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073efb6c",
  null
  
)

export default component.exports